/*
 * @Description:
 * @Date: 2024-03-18 18:15:22
 */
import {
  BaseCheckbox,
  BaseCheckboxGroup,
  BaseEmpty,
  createDialog,
  XrkLoadingDirective,
  BaseTextContent
} from 'xrk-components';
import _ConfigTagsVue from './config-tags.vue';
import { ref, withDirectives } from 'vue';
import { TagType } from '../../data-source/types';
import { getTagList } from '../../data-source/api';
import { useZsStore } from '../../store';

export const ConfigTagsVue = _ConfigTagsVue;

export const chooseTags = (choosedDataIds: Set<number | string>) => {
  const { tagsData, loading, chooseIds } = (() => {
    const tagsData = ref<Array<TagType>>([]);
    const loading = ref(true);
    const chooseIds = ref<Array<number | string>>();
    const initData = async () => {
      const { data } = await getTagList({
        enterpriseId: useZsStore().enterpriseId.value
      });
      tagsData.value = data.filter(tag => !choosedDataIds.has(tag.id));
      loading.value = false;
    };
    initData();
    return { tagsData, loading, chooseIds };
  })();
  return new Promise<Array<TagType>>(resolve => {
    createDialog({
      title: '选择能力标签',
      width: 600,
      contentRender: () => {
        return (
          <BaseTextContent>
            <div>
              {tagsData.value.length === 0 ? (
                withDirectives(
                  <BaseEmpty style={{ height: '200px' }}></BaseEmpty>,
                  [[XrkLoadingDirective.directive, loading.value]]
                )
              ) : (
                <BaseCheckboxGroup
                  style={{ width: '100%' }}
                  modelValue={chooseIds.value}
                  onChange={vals => {
                    chooseIds.value = vals;
                  }}
                >
                  {tagsData.value.map((tag, index) => {
                    return (
                      <div
                        style={{
                          width: '100%',
                          marginTop: index > 0 ? '16px' : ''
                        }}
                      >
                        <BaseCheckbox value={tag.id}>
                          <span
                            style={{ fontWeight: 'bold', fontSize: '16px' }}
                          >
                            {tag.name}
                          </span>
                        </BaseCheckbox>
                        {!tag.isLocation && (
                          <div
                            style={{
                              marginTop: '8px',
                              border: '1px solid #DDDDDD',
                              borderRadius: '4px',
                              padding: '8px 16px',
                              fontSize: '14px',
                              color: '#666666',
                              display: 'flex',
                              gap: '12px',
                              flexWrap: 'wrap',
                              lineHeight: 1.2,
                              width: '560px'
                            }}
                          >
                            {tag.childList.map(child => {
                              return <div>{child.name}</div>;
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </BaseCheckboxGroup>
              )}
            </div>
          </BaseTextContent>
        );
      },
      confirmBtnConfig: {
        show: true,
        type: 'primary',
        content: '保存'
      },
      cancelBtnConfig: { show: true, type: 'default', content: '取消' },
      beforeConfirm: done => {
        const chooseIdsSet = new Set(chooseIds.value);
        resolve(tagsData.value.filter(tag => chooseIdsSet.has(tag.id)));
        done();
      }
    });
  });
};
